// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-native-live-markdown-input-singleline {
  white-space: nowrap;
  overflow: auto;
}

.react-native-live-markdown-input-singleline::-webkit-scrollbar {
  display: none;
}

.react-native-live-markdown-input-singleline br {
  display: none;
}

.react-native-live-markdown-input-singleline * {
  display: inline;
  white-space: nowrap;
}

.react-native-live-markdown-input-singleline:empty::before,
.react-native-live-markdown-input-multiline:empty::before {
  pointer-events: none;
  display: block; /* For Firefox */
  content: attr(placeholder);
}
`, "",{"version":3,"sources":["webpack://./node_modules/@expensify/react-native-live-markdown/lib/module/web/MarkdownTextInput.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,oBAAoB;EACpB,cAAc,EAAE,gBAAgB;EAChC,0BAA0B;AAC5B","sourcesContent":[".react-native-live-markdown-input-singleline {\n  white-space: nowrap;\n  overflow: auto;\n}\n\n.react-native-live-markdown-input-singleline::-webkit-scrollbar {\n  display: none;\n}\n\n.react-native-live-markdown-input-singleline br {\n  display: none;\n}\n\n.react-native-live-markdown-input-singleline * {\n  display: inline;\n  white-space: nowrap;\n}\n\n.react-native-live-markdown-input-singleline:empty::before,\n.react-native-live-markdown-input-multiline:empty::before {\n  pointer-events: none;\n  display: block; /* For Firefox */\n  content: attr(placeholder);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
